import axios from 'axios';

import apiConfig from '../api.config';

export default function updateBookingStatus({ hotelId, bookingId, status }) {
  const {
    host,
    URIs: { updateBookingStatus },
  } = apiConfig;

  const uri = `${host}${updateBookingStatus}`
    .replace(':hotelId', hotelId)
    .replace(':bookingId', bookingId);

  return axios
    .put(uri, JSON.stringify({ status }), {
      headers: { 'Content-Type': 'application/json' },
    })
    .then(res => res.data);
}
